import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initTheme } from '@/components/organisms/Shell/shellState'
import { readRememberedEmail } from '@/utils/rememberedLogin'
initTheme()
readRememberedEmail()
watchInstallPrompt()
import store from './store'
import { firebaseConfigured } from '@/config/firebaseInit';
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import '@formkit/themes/genesis'
import '@formkit/pro/genesis'
import { bindFormKitApp } from '@/plugins/customFieldView/lazyFormKit'
import 'v-calendar/style.css';
import { i18n, applyStoredLocale } from '@/locales/main';
import { registerLazyGlobals } from '@/config/lazyGlobals';
import DemoBanner from "@/components/atom/DemoBanner/DemoBanner.vue";
import { installChunkRecovery } from '@/config/chunkRecovery';
import { registerShellWorker } from '@/serviceWorker/registration';
import { watchInstallPrompt } from '@/serviceWorker/installPrompt';
// Plugins Path
import registerPlugin from './plugins/register/registerPlugin';
import createcompanyinsidePlugin from './plugins/createcompanyinside/createcompanyinsidePlugin';
import chargebeePlugin from './plugins/chargebee/chargebeePlugin';
import paddlePlugin from './plugins/paddle/paddlePlugin';
import customfieldPlugin from './plugins/customFieldView/customFieldPlugin';
import dashboardPlugin from './plugins/dashboard/dashboardPlugin';
import importTasksPlugin from './plugins/importTasks/importTasksPlugin';
import exportTasksPlugin from './plugins/exportTasksPlugin/exportTasksPlugin';
import tasklistDashboardPlugin from './plugins/tasklistDashboard/tasklistDashboardPlugin';
import importUsersPlugin from './plugins/importUsers/importUsersPlugin';
import oAuthPlugin from './plugins/oauth/oAuthPlugin';


/**
 * CSS files
 */

import "@/assets/css/index.css";
import "@/assets/css/alerts.css";
import "@/assets/css/driver.css";

const app = createApp(App).use(store).use(router)

// Plugin Setup
const pluginArray = [
  registerPlugin,
  createcompanyinsidePlugin,
  chargebeePlugin,
  paddlePlugin,
  customfieldPlugin,
  dashboardPlugin,
  importTasksPlugin,
  exportTasksPlugin,
  tasklistDashboardPlugin,
  importUsersPlugin,
  oAuthPlugin
];
for (let index = 0; index < pluginArray.length; index++) {
  app.use(pluginArray[index]);
}

app.use(ToastPlugin,{position: 'top-right'});
bindFormKitApp(app);
app.use(i18n);
// Registered before mount so the root App.vue template can resolve it.
app.component('DemoBanner', DemoBanner);
installChunkRecovery(app, router);
registerLazyGlobals(app);

const TELEPORT_TARGETS = ['my-sidebar', 'my-modal', 'my-dropdown', 'my-image-slider'];

const mountApp = () => {
  app.mount('#app');
  // Mounting empties #app, so the teleport targets go in afterwards.
  TELEPORT_TARGETS.forEach((id) => {
    const element = document.createElement('div');
    element.id = id;
    document.getElementById('app')?.appendChild(element);
  });
};

// The first paint waits for the stored language's file; English alone needs no wait.
applyStoredLocale().then(mountApp);

/* A scope holds one worker, and "/" belongs to the app shell's (sw.js). The push worker goes under the
 * scope the Firebase SDK registers it with when it asks for a token, so both calls name the same one.
 * firebase-messaging-sw.js only exists once frontend/config.sh has copied it into public/. */
const PUSH_WORKER_SCOPE = '/firebase-cloud-messaging-push-scope';
if (firebaseConfigured && 'serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: PUSH_WORKER_SCOPE })
    .catch((error) => {
      console.info('Service worker registration failed:', error);
    });
}

if (document.readyState === 'complete') registerShellWorker();
else window.addEventListener('load', () => registerShellWorker(), { once: true });
